module.exports = __webpack_public_path__ + "img/credit-card-visa-master.24f7a2ae.png";